import { getcounted } from '@/redux/faq/action';
import store from '@/redux/index';
import { IM_FAQ, IM_MESSAGE } from '@/typings/global';
import { PAYLOAD_FAQ_LABEL } from '@/typings/payload';

export const faqChoice = async (
    payload: PAYLOAD_FAQ_LABEL,
    list: IM_FAQ[],
    type: 'faq' | 'hot_label' = 'hot_label'
): Promise<IM_MESSAGE | IM_MESSAGE[]> => {
    const { dispatch, getState } = store;
    const { start, message = null, log_id = '0' } = payload;
    const len = list?.length;
    if (list) {
        const firstItem = list[0];
        const createFaqResolve = async (resolveType: 'faq' | 'hot_label'): Promise<IM_MESSAGE> => {
            const resolvedLogId =
                resolveType === 'hot_label'
                    ? (
                          (await getcounted({
                              faq_id: firstItem.id,
                              pid: log_id
                          })(dispatch, getState)) as { log_id: number }
                      ).log_id
                    : log_id;
            return {
                message: null,
                type: 'faq-resolve',
                ctx: { ...firstItem, log_id: resolvedLogId } as any
            };
        };
        const createFaqQuestions = (items: IM_FAQ[]): IM_MESSAGE => ({
            message: null,
            type: 'faq-questions',
            ctx: items.map((item) => ({ ...item, log_id })) as any
        });
        if (type === 'faq') {
            if (len === 1) return createFaqResolve(type);
            if (len > 1) {
                const faqResolveMsg: IM_MESSAGE = {
                    message: null,
                    type: 'faq-resolve',
                    ctx: { ...firstItem, log_id } as any
                };
                return [faqResolveMsg, createFaqQuestions(list.slice(1))];
            }
        }
        if (type === 'hot_label') {
            if (len === 1) return createFaqResolve(type);
            if (len > 1) return createFaqQuestions(list);
        }
    }
    if (start) {
        return { message, type: 'faq-art', ctx: { log_id, start } };
    }
    return { message, type: 'in' };
};
/**
 * 解决/未解决
 */
export const faqResolve = (payload): IM_MESSAGE => {
    const { solve, start, message } = payload;
    if (solve === 0) {
        if (start === 0) {
            return { message, type: 'in' };
        }
        return { message, type: 'faq-art', ctx: payload };
    }
    if (solve === 1) {
        return { message, type: 'in' };
    }
};
